<template>
    <div id="teamMerge" class="only-content">
        <div class="header">
            <Form :label-width="90" inline :model="params" ref="teamParamsForm" style="width:100%">
                <Row>
                    <Col span="5">
                        <FormItem label="管理机构" prop="deptCode">
                            <Select clearable transfer @on-open-change="selectUpDown" v-model.trim="params.deptCode" placeholder="请选择机构名称/代码">
                                <Option :value="item.deptCode" :key="item.deptCode" v-for="item in companyList.customList">{{item.deptName}} / {{item.deptCode}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <FormItem label="合并类型" prop="mergeType">
                            <Select clearable transfer @on-open-change="selectUpDown" v-model.trim="params.mergeType" placeholder="请选择合并类型">
                                <Option  value="1">营业区合并</Option>
                                <Option  value="2">营业部合并</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <FormItem label="审核状态" prop="status">
                            <Select clearable transfer @on-open-change="selectUpDown" v-model.trim="params.status" placeholder="请选择审核状态">
                                <Option value="0">通过</Option>
                                <Option value="1">未通过</Option>
                                <Option value="2">审批中</Option>
                                <Option value="3">待提交</Option>
                                <Option value="4">已撤回</Option>
                                <Option value="6">已失效</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <FormItem label="生效日期" prop="effectiveDate">
                            <DatePicker transfer type="date" @on-change="(val) =>{ params.effectiveDate = val}" v-model="params.effectiveDate"></DatePicker>
                        </FormItem>
                    </Col>
                    <Col  style="float: right">
                    <Button type="primary" @click="search">查询</Button>
                        <Button @click="reset">重置</Button>
                    </Col>
                </Row>


                <div style="margin-bottom:20px">
                    <div id="moreBtn" class="searchUpDownBtn" style="margin-bottom:6px;">
                        <Icon type="ios-arrow-down"  @click="moreFun()"/>
                        <span @click="moreFun()">更多条件</span>
                    </div>
                    <div id="moreCondition">
                        <Row>
                            <FormItem label="日期类型" prop="dateType">
                                <Select clearable transfer @on-open-change="selectUpDown" v-model.trim="params.dateType" placeholder="请选择日期类型">
                                    <Option value="1">提交日期</Option>
                                    <Option value="2">审批日期</Option>
                                </Select>
                                <DatePicker transfer type="daterange" :value="params.date" @on-change="date=>{params.date=date;params.startDate=date[0];params.endDate=date[1]}" placeholder="请选择日期范围" style="margin-left:8px;"></DatePicker>
                            </FormItem>
                        </Row>


                    </div>
                    <div id="upBtn" class="searchUpDownBtn">
                        <Icon type="ios-arrow-up"  @click="upFun()"/>
                        <span @click="upFun()">收起</span>
                    </div>
                </div>

            </Form>
        </div>
        <div style="margin-bottom: 15px">
            <Button type="primary" @click="quitApply('add')" v-if="button.moveApply_addMerge">新增申请</Button>
        </div>
        <div>
            <primaryTable
                    :columns="columns"
                    :data="data"
                    :loading="tableLoading"
                    :total="total"
                    @on-change="changePage"
                    @on-page-size-change="changeSize"
            ></primaryTable>
        </div>
        <Modal v-model.trim="auditModal" title="审批记录" width="900">
            <Row>
                <Col>
                    <ModalLog :auditList="auditList" checkLogType="审批记录"  :auditNo="auditNo"></ModalLog>
                </Col>
            </Row>
        </Modal>
        <Modal class="Modal_html" title="团队合并申请" v-model.trim="teamMergeModalFlag" width="1000" :footer-hide="isSee">
            <Form ref="formValidate_teamMerge" :disabled="isSee"  :model="formValidate_teamMerge" :rules="formValidate" :label-width="100" style="width: 100%;">
                <!-- 基本信息 -->
                <Row>
                    <br>
                    <!-- <h3 class="marginLeft30" style="margin-left:35px;margin-bottom: 10px;">提交信息</h3> -->
                    <Col span="12">
                        <FormItem label="管理机构/代码" prop="deptCode">
                            <Select clearable transfer @on-open-change="selectUpDown"  v-model.trim="formValidate_teamMerge.deptCode" :disabled="isReady" placeholder="请选择" @on-change="getChildByCode(formValidate_teamMerge.deptCode,'areaList','deptName',companyList.customList,4)">
                                <Option :value="item.deptCode" :key="item.deptCode" v-for="item in companyList.customList">{{item.deptName}} / {{item.deptCode}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="申请营业区" prop="areaCode">
                            <Select v-if="!isSee" transfer clearable @on-open-change="selectUpDown"  v-model.trim="formValidate_teamMerge.areaCode" placeholder="请选择" @on-change="getChildByCode(formValidate_teamMerge.areaCode,'teamList','areaName',areaList,5)" >
                                <Option :value="item.marketCode" :key="item.marketCode" v-for="item in areaList">{{item.marketName}} / {{item.marketCode}}</Option>
                            </Select>
                             <Input v-else v-model.trim="formValidate_teamMerge.areaName" disabled/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="申请营业部"  prop="teamCode">
                            <Select v-if="!isSee" transfer clearable @on-open-change="selectUpDown"   v-model.trim="formValidate_teamMerge.teamCode" @on-change="teamCodeChange">
                                <Option :value="item.marketCode" :key="item.marketCode" v-for="item in teamList">{{item.marketName}} / {{item.marketCode}}</Option>
                            </Select>
                             <Input v-else v-model.trim="formValidate_teamMerge.teamName" disabled/>
                        </FormItem>
                    </Col>

                </Row>
                <Row>
                    <Col span="12">
                        <FormItem  prop="isRank">
                            <Checkbox v-model.trim="isRank">营业区合并</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
                <!--合并类别-->
                <Row v-if="isRank">
                    <h3 class="marginLeft30" style="margin-left:35px;margin-bottom: 10px">营业区合并</h3>
                    <Col span="12">
                        <FormItem label="合并至营业区"  prop="changeMergeDTO.mergeToAreaCode">
                            <Select v-if="!isSee" clearable transfer @on-open-change="selectUpDown" 
                                    placeholder="请选择" filterable v-model.trim="formValidate_teamMerge.changeMergeDTO.mergeToAreaCode"   @on-change="changeFormType(formValidate_teamMerge.changeMergeDTO.mergeToAreaCode,'mergeToArea',areaList)">
                                <Option :value="item.marketCode" :key="item.marketCode" v-for="item in areaList">{{item.marketName}} / {{item.marketCode}}</Option>
                            </Select>
                               <Input v-else v-model.trim="formValidate_teamMerge.changeMergeDTO.mergeToArea" disabled/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="职级名称"  prop="rankCode">
                            <Select clearable transfer @on-open-change="selectUpDown"  v-model.trim="formValidate_teamMerge.rankCode" disabled>
                                    <Option :value="item.rankCode" v-for="(item,index) in rankTypeList" :key="index">{{item.rankName}} / {{item.rankCode}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                            <FormItem label="新负责人编码" prop="agentCode">
                               <InputModal
                               value="agentCode"
                               :disabled="isReady"
                               :form.sync="formValidate_teamMerge"
                               :ApiList="[
                                 {'agentCode':'agentCode'},
                                 {'agentName':'agentName'},
                                 {'postName':'postName'},
                                 {'postCode':'postCode'},
                                 {'rankCode':'rankCode'},
                                 {'rankName':'rankName'}
                               ]"
                               >
                               </InputModal>
                            </FormItem>
                        </Col>
                    <Col span="12">
                        <FormItem label="新负责人名称"  prop="agentName">
                            <Input v-model.trim="formValidate_teamMerge.agentName" disabled/>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem  prop="isCexzl">
                            <Checkbox v-model.trim="isCexzl">营业部合并</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
<!--营业部合并-->
                <Row v-if="isCexzl">
                    <h3 class="marginLeft30" style="margin-left:35px;margin-bottom: 10px">营业部合并</h3>
                    <Col span="12">
                        <FormItem label="合并至营业部" prop="changeMergeDTO.mergeToTeamCode" v-if="isCexzl">
                            <Select clearable transfer @on-open-change="selectUpDown"  placeholder="请选择" v-model.trim="formValidate_teamMerge.changeMergeDTO.mergeToTeamCode" :disabled="isReady"   @on-change="changeFormType(formValidate_teamMerge.changeMergeDTO.mergeToTeamCode,'mergeToTeam',teamList)">
                                <Option :value="item.marketCode" :key="item.marketCode" v-for="item in teamList">{{item.marketName}} / {{item.marketCode}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="职级名称"  prop="rankCode">
                            <Select clearable transfer @on-open-change="selectUpDown"  v-model.trim="formValidate_teamMerge.rankCode" disabled>
                                <Option :value="item.rankCode" v-for="item in rankTypeList" :key="item.id">{{item.rankName}} / {{item.rankCode}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="新负责人编码" prop="agentCode">
                            <InputModal
                                    value="agentCode"
                                    :form.sync="formValidate_teamMerge"
                                    :disabled="isReady"
                                    :ApiList="[
                                 {'agentCode':'agentCode'},
                                 {'agentName':'agentName'},
                                 {'postName':'postName'},
                                 {'postCode':'postCode'},
                                 {'rankCode':'rankCode'},
                                   {'rankName':'rankName'}
                               ]"
                            >
                            </InputModal>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="新负责人名称"  prop="agentName">
                            <Input v-model.trim="formValidate_teamMerge.agentName" disabled/>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <h3 class="marginLeft30" style="margin-left:35px;margin-bottom: 10px">时间信息</h3>
                    <Col span="12">
                        <FormItem label="生效日期" prop="effectiveDate">
                            <DatePicker  transfer  disabled  type="date" v-model='formValidate_teamMerge.effectiveDate'
                                    @on-change="(val) => formValidate_teamMerge.effectiveDate = val === ''? '' : val" style="width: 100%"></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem label="申请提交人"  >
                            <Input v-model.trim="curCreatedUser" disabled/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="申请日期" prop="date" >
                           <DatePicker transfer type="date" clearable :value="formValidate_teamMerge.submitDate" :on-change="date=>{formValidate_teamMerge.submitDate=date}" placeholder="请输入" disabled style="width: 100%;"></DatePicker>
                        </FormItem>
                    </Col>
                </Row>


                <!--上传附件-->
                <Row>
                    <h3 class="marginLeft30" style="margin-left:35px;margin-bottom: 10px;">附件
                    </h3>
                </Row>
                <div>
                    <FormItem class="fileStyle" label="上传文件" prop="changeAttachmentDTO">
                        <div style="display: flex;flex-wrap: wrap">
                             <span v-for="(item,index) in formValidate_teamMerge.changeAttachmentDTO" :key="index" >
                           <div class="demo-upload-list">
                                <img :src="$api.imgLoadUrl + item.filePath + '?sid='+headers.sid">
                                <div class="demo-upload-list-cover">
                                    <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                                    <Icon type="ios-trash-outline" @click.native="delFormValidate_relationImage(item,index)"></Icon>
                                </div>
                            </div>
                          <div style="text-align: center;width:200px;" class="ellipsis" :title="item.fileName">{{item.fileName}}</div>
                            </span>
                        </div>
                    </FormItem>
                </div>
                <Row v-if="!isSee">
                    <FormItem label="">
                        <div v-if="formValidate_teamMerge.changeAttachmentDTO.length < 20">
                            <Upload
                                    :action=action
                                    ref="upload"
                                    name="files"
                                    :show-upload-list="false"
                                    :format="['jpg','pdf','png']"
                                    :headers=headers
                                    type="drag"
                                    :on-success="handSuccess"
                                    accept=".jpg,.pdf,.png"
                                    :data="fileData"
                            >
                                <div style="height: 90px">
                                    <Icon type="ios-cloud-upload" size="22"
                                          style="color: #3399ff"></Icon>
                                    <p>支持jpg/png格式图片；支持PDF文件</p>
                                </div>
                            </Upload>
                        </div>
                    </FormItem>
                </Row>
            </Form>



            <div slot="footer">
                <Button  @click="teamMergeModalFlag=false">取消</Button>
                <Button type="primary" @click="submit('0')" v-if="!isReady && !isEdit">确认提交</Button>
                <Button type="primary" ghost @click="submit('1')" v-if="!isReady && !isEdit">保存</Button>
                <Button type="primary" @click="reSubmit('0')" v-if="isEdit">再次提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "teamMerge",
        IsUpload:false,
        props:{
            headers:{
                type:Object
            },
            rankTypeList:{
                type:Array
            },
            companyList:{
                type:Object
            },
        },
        data(){
            return{
                isRank: true,
                isCexzl: false,
                button:this.$store.state.app.button,
                formValidate:{
                    agentCode:[
                        {required:true,message:'请选择新负责人代码'}
                    ],
                    deptCode:[
                        {required:true,message:'请选择机构'}
                    ],
                    areaCode:[
                        {required:true,message:'请选择申请营业区'}
                    ],
                    effectiveDate:[
                        //{required:true,message:'请选择生效日期'}
                    ],
                    'changeMergeDTO.mergeToAreaCode': [
                        {required:true,message:'请选择必填项'}
                    ],
                    'changeMergeDTO.mergeToTeamCode':[
                        {required:true,message:'请选择必填项'}

                    ],
                     "changeAttachmentDTO":[
                         /* {required:true} */
                         ]
                },
                curCreatedUser:"",
                isSee: false,
                isReady:false,
                isEdit:false,
                auditModal:false,
                auditList:[],
                auditNo:'',
                areaList:[],
                teamList:[],
                groupList:[],
                afterAreaList:[],
                afterTeamList:[],
                afterGroupList:[],
                params:{
                    deptCode:'',
                    nameOrCode:'',
                    mergeType:'',
                    page:1,
                    pageSize:10,
                    dateType:'',
                    effectiveDate:'',
                    effectiveStartDate:'',
                    effectiveEndDate:'',
                    date:[],
                    startDate:'',
                    endDate:'',
                    status:''
                },
                total:0,
                formValidate_teamMerge: {
                    areaCodeAndName:"",
                    changeAttachmentDTO: [],
                    changeType:4,
                    saveFlag:'',//	是	string	保存类型 0 提交申请 1 保存
                    agentName:'',//	是	string	新负责人姓名
                    agentCode:'',//	是	string	新负责人编码
                    postCode:'',//	否	string	岗位编码
                    postName:'',//	否	string	岗位名称
                    rankCode:'',//	是	string	职级编码
                    rankName:'',//	是	string	职级名称
                    effectiveDate:'',//	是	date	生效日期 yyyy-MM-dd
                    deptCode:'',//	是	string	管理机构编码
                    deptName:'',//	是	string	管理机构级名称
                    areaCode:'',//	是	string	申请合并营业区编码
                    areaName:'',//	是	string	申请合并营业区名称
                    teamCode:'',//	否	string	申请合并营业部编码
                    teamName:'',//	否	string	申请合并营业部名称
                    groupCode:'',//	否	string	申请合并营业组编码
                    groupName:'',//	否	string	申请合并营业组名称
                    changeMergeDTO:{
                        type:'',//	是	string	合并类型 1-区合并；2-部合并；3-组合并
                        mergeToAreaCode:'',//	是	string	合并至营业区编码
                        mergeToArea:'',//	是	string	合并至营业区名称
                        mergeToTeamCode:'',//	否	string	合并至营业部编码
                        mergeToTeam:'',//	否	string	合并至营业部名称
                        mergeToGroupCode:'',//	否	string	合并至营业组编码
                        mergeToGroup:'',//	否	string	合并至营业组名称
                    }

                },
                teamMergeModalFlag:false,
                data:[
                    {
                        auditCode:'123'
                    }
                ],
                tableLoading: false,
                action:this.$api.enclosureUpload,
                fileData:{
                    fileType:3
                },
                columns: [
                    // {
                    //     title:'审批代码',
                    //     key:'approvalId',
                    //     align:'center',
                    //     fixed: 'left',
                    //     minWidth:140,
                    //     render:(h,p)=>{
                    //         return h('a',{
                    //             on:{
                    //                 click:()=>{
                    //                      this.quitApply('see',p.row)
                    //                 }
                    //             }
                    //         },p.row.approvalId)
                    //     }
                    // },
                    {
                        title:'管理机构代码',
                        key:'deptCode',
                        align:'center',
                        minWidth:150
                    },
                    {
                        title:'管理机构名称',
                        key:'deptName',
                        align:'center',
                        minWidth:150
                    },

                    {
                        title:'合并类型',
                        key:'mergeType',
                        align:'center',
                        minWidth:140,
                        render:(h,p)=>{
                            let text;
                            switch (p.row.mergeType) {
                                case '1':
                                    text='营业区合并';
                                    break
                                case '2':
                                    text='营业部合并';
                                    break
                            }
                            return h('div',text)
                        }
                    },
                    {
                        title:'申请销售机构代码',
                        key:'applyDeptCode',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'申请销售机构名称',
                        key:'applyDeptName',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'合并至销售机构代码',
                        key:'mergeToDeptCode',
                        align:'center',
                        minWidth:150
                    },
                    {
                        title:'合并至销售机构名称',
                        key:'mergeToDeptName',
                        align:'center',
                        minWidth:150
                    },
                    {
                        title:'新负责人代码',
                        key:'agentCode',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'新负责人姓名',
                        key:'agentName',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'职级名称',
                        key:'rankName',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'生效日期',
                        key:'effectiveDate',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'申请提交人',
                        key:'createdUser',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'提交日期',
                        key:'submitDate',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'审批日期',
                        key:'approvalDate',
                        align:'center',
                        minWidth:140
                    },
                    {
                        title:'审批状态',
                        key:'status',
                        align:'center',
                        minWidth:140,
                        render:(h,p)=>{
                            let text;
                            switch (p.row.status) {
                                case 0:
                                    text='通过 ';
                                    break
                                case 1:
                                    text='未通过';
                                    break
                                case 2:
                                    text='审批中';
                                    break
                                case 3:
                                    text='待提交';
                                    break
                                case 4:
                                    text='已撤回';
                                    break
                                case 5:
                                    text='通过';
                                    break
                            }
                            return h('div',text)
                        }
                    },
                    {
                        title:'操作',
                        key:'',
                        fixed:'right',
                        align:'center',
                        minWidth:300,
                        render:(h,p)=>{
                            return h('div',[
                                (this.button.moveApply_seeMerge)?  h('Button',{
                                    props:{
                                        type:'primary',
                                        size:'small',
                                    },
                                    on:{
                                        click:()=>{
                                            this.quitApply('see',p.row)
                                        }
                                    }
                                },'查看'):'',
                                (this.button.moveApply_editMerge)?  h('Button',{
                                    props:{
                                        type:'primary',
                                        size:'small',
                                        disabled:(p.row.status==3 || p.row.status==4 )?false:true
                                    },
                                    on:{
                                        click:()=>{
                                            this.quitApply('edit',p.row)
                                        }
                                    }
                                },'编辑提交'):'',
                                (this.button.moveApply_withdrawMerge)?h('Button',{
                                    props:{
                                        type:'error',
                                        size:'small',
                                        disabled:(p.row.status!=2)?true:false
                                    },
                                    on:{
                                        click:()=>{
                                            this.withdraw(p.row)
                                        }
                                    }
                                },'撤回'):'',
                                // (this.button.moveApply_recordMerge)?h('Button',{
                                //     props:{
                                //         type:'primary',
                                //         ghost:true,
                                //         size:'small',
                                //         disabled:p.row.approvalId?false:true
                                //     },
                                //     on:{
                                //         click:()=>{
                                //             this.getAuditList(p.row)
                                //         }
                                //     }
                                // },'审批记录'):''
                            ])
                        }
                    },

                ]
            }
        },
        created(){
            if(!this.button.moveApply_withdrawMerge && !this.button.moveApply_editMerge && !this.button.moveApply_recordMerge){
               this.columns.pop()
            }
            this.mergePage()
        },
        mounted() {
            this.$nextTick(()=>{
                document.getElementById('moreCondition').style.display = 'none'
                document.getElementById('upBtn').style.display = 'none'
            })
        },
        methods:{
            changeEffectiveDate(val){
                if(val){
                    //是日期格式
                    if(isNaN(val)&&!isNaN(Date.parse(val))){
                         this.formValidate_teamMerge.effectiveDate=this.$util.getFormatOnlyDate(val)
                         console.log(this.formValidate_teamMerge.effectiveDate)
                    }
                }
            },
            handleView (item) {
                console.log(item);
                window.open(this.$api.imgLoadUrl + item.filePath + '?sid='+ this.headers.sid)
            },
            //删除文件
            delFormValidate_relationImage(item, index){
                this.formValidate_teamMerge.changeAttachmentDTO.splice(index , 1)
            },
            teamCodeChange (val) {
                this.teamList.map(item =>{
                    if (item.marketCode === val) {
                        this.formValidate_teamMerge.teamName = item.marketName
                    }
                })
            },
            delFormValidate_leaveImage(){
                this.formValidate_teamMerge.changeAttachmentDTO={}
            },
            handSuccess(res,file,fileList){
                if(res.content.success){
                    file.name=file.name.toLowerCase();
                    if(file.name.indexOf('jpg')!=-1 ){
                        res.content.content.files[0].type='0'
                    }
                    if(file.name.indexOf('pdf')!=-1){
                        res.content.content.files[0].type='2'
                    }
                    if(file.name.indexOf('png')!=-1){
                        res.content.content.files[0].type='1'
                    }
                    res.content.content.files.map(item =>{
                        item.url = item.filePath
                    })
                    console.log(this.formValidate_relation);
                    // res.content.content.files[0].url=t his.formValidate_relation.changeAttachmentDTO.filePath;
                    this.formValidate_teamMerge.changeAttachmentDTO.push(res.content.content.files[0]);
                }else{
                    this.$Message.error({
                content:  res.content.resultMessage ? res.content.resultMessage : res.message,
                duration: 8
            });
                }
            },


            //根据id获取详情
            getDetailById(params){
                this.$api.getMergeDetail({id:params.id}).then(res=>{
                    if(res.respCode==0){
                        if(res.data.changeAttachmentDTO.filePath==''){
                            res.data.changeAttachmentDTO={}
                        }
                        if (res.data.changeMergeDTO.type === '1') {
                            this.isRank = true
                        } else {
                            this.isCexzl = true
                        }
                        this.formValidate_teamMerge=res.data;
                        console.log(this.formValidate_teamMerge.changeMergeDTO.mergeToAreaCode);
                        if (res.data.deptCode !== null) {
                            this.getChildByCode(this.formValidate_teamMerge.deptCode,'areaList','deptName',this.companyList.customList,4)
                        }
                        if (this.formValidate_teamMerge.areaCode !== null) {
                            this.getChildByCode(this.formValidate_teamMerge.areaCode,'teamList','areaName', this.areaList,5)
                        }
                        this.formValidate_teamMerge.areaCodeAndName=this.formValidate_teamMerge.areaName+"/"+this.formValidate_teamMerge.areaCode
                        this.formValidate_teamMerge.approvalStatus = params.status
                        console.log('-------------------11-----------');
                        console.log(this.formValidate_teamMerge.changeMergeDTO.mergeToAreaCode);
                        console.log(this.formValidate_teamMerge.changeMergeDTO);

                        this.teamMergeModalFlag=true
                    }else {
                        this.$Message.error(res.resultMessage)
                    }
                })
            },
            formValidate_teamMergeF(){
              this.$refs.formValidate_teamMerge.resetFields()
            },
            //新增保存
            saveUs(type){
                     this.formValidate_teamMerge.applyFrom=0;
                this.formValidate_teamMerge.saveFlag=type;
                this.$api.mergeCreate(this.formValidate_teamMerge).then(res=>{
                    if(res.respCode==0){
                        this.formValidate_teamMergeF();
                        this.$Message.success('新建成功');
                        this.search();
                        this.teamMergeModalFlag=false;
                    }else{
                        this.$Message.error(res.resultMessage)
                    }
                })
            },
            //再次提交
            reSubmit(type){
                this.formValidate_teamMerge.applyFrom=0;
                this.formValidate_teamMerge.saveFlag=type;
                console.log(this.formValidate_teamMerge)
                  // if(!isNaN(Date.parse(this.formValidate_teamMerge.effectiveDate))){
                  //        this.formValidate_teamMerge.effectiveDate=this.$util.getFormatOnlyDate(this.formValidate_teamMerge.effectiveDate)
                  //        console.log(this.formValidate_teamMerge.effectiveDate)
                  //   } else{
                  //       this.formValidate_teamMerge.effectiveDate=this.formValidate_teamMerge.effectiveDate+"-01"
                  //   }
                 /*  if(this.formValidate_teamMerge.changeAttachmentDTO.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
                this.$refs.formValidate_teamMerge.validate(item=> {
                    if (item) {
                        this.$api.mergeReSubmit(this.formValidate_teamMerge).then(res=>{
                            if(res.respCode==0){
                                this.formValidate_teamMergeF();
                                this.$Message.success('修改成功');
                                this.search();
                                this.teamMergeModalFlag=false;
                            }else{
                                this.$Message.error(res.resultMessage)
                            }
                        });
                    }
                })
            },
            //提交
            submit(type){
               /*  if(this.formValidate_teamMerge.changeAttachmentDTO.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
                this.$refs.formValidate_teamMerge.validate(item=>{
                    if(item){
                        this.saveUs(type)
                    }
                });
            },
            //清空选择后的之前的合并数据
            resetForm(){
                // this.formValidate_teamMerge.changeMergeDTO.mergeToAreaCode='';//	是	string	合并至营业区编码
                // this.formValidate_teamMerge.changeMergeDTO.mergeToArea='';//	是	string	合并至营业区名称
                // this.formValidate_teamMerge.changeMergeDTO. mergeToTeamCode='';//	否	string	合并至营业部编码
                // this.formValidate_teamMerge.changeMergeDTO.mergeToTeam='';//	否	string	合并至营业部名称
                // this.formValidate_teamMerge.changeMergeDTO. mergeToGroupCode='';//	否	string	合并至营业组编码
                // this.formValidate_teamMerge.changeMergeDTO. mergeToGroup='';//
            },
            //根据code 查询下级机构
            getChildByCode(code,list,name,arrList,deptId){
                this.getChild(code,deptId,this,arr=>{
                    this[list]=arr;
                     console.log(this.areaList)
                     console.log(list)
                       console.log(arr)
                    this.resetForm();
                    this.changeFormType(code,name,arrList)

                })

            },
            //改变显示合并的机构名称 以及获取type
            changeFormType(code,name,list){
                    if(name==='groupName'){
                        this.resetForm()
                    }
                if(code==undefined){
                    return false
                }else{
                    // if(name==='deptName'){
                    //     this.formValidate_teamMerge.changeMergeDTO.type=''
                    // } else if(name==='areaName'){
                    //     this.formValidate_teamMerge.changeMergeDTO.type='1'
                    // }else if(name==='teamName'){
                    //     this.formValidate_teamMerge.changeMergeDTO.type='2'
                    // } else if(name==='groupName'){
                    //     this.formValidate_teamMerge.changeMergeDTO.type='3'
                    // }
                }
                console.log(name);
                console.log(code);
                for(let a =0;a<list.length;a++){
                    console.log(list[a]);
                    if(name.indexOf('mergeTo')!==-1){
                            if(list[a].deptCode==code){
                                this.formValidate_teamMerge.changeMergeDTO[name]=list[a].deptName;
                            }
                        }else{
                            if(list[a].deptCode==code){
                                this.formValidate_teamMerge[name]=list[a].deptName;
                            }
                        }
                    if (name === 'areaName' && list[a].marketCode === code) {
                        this.formValidate_teamMerge.areaName=list[a].marketName;
                    }
                    if (name === 'mergeToArea' && list[a].marketCode === code) {
                        this.formValidate_teamMerge.changeMergeDTO.mergeToArea=list[a].marketName;
                    }
                }
            },
            //审批记录
            getAuditList(row){
                this.$api.getActivityHis({processInstanceId:row.approvalId}).then(res=>{
                    if(res.respCode==0) {
                        this.auditModal=true;
                        this.auditNo=row.approvalId;
                        this.auditList = res.data;
                    }
                    else{
                        this.$Message.error(res.message);
                    }
                })
            },
            //翻页
            changePage(page){
                this.params.page=page;
                this.mergePage()
            },
            //改变页码
            changeSize(size){
                this.params.pageSize=size;
                this.mergePage()
            },
            reset(){
                this.params={}
                this.params.date=[];
                this.params.startDate="";
                this.params.endDate="";
                this.params.effectiveDate="";
                this.$refs.teamParamsForm.resetFields();
                this.search()
            },
            search(){
                this.params.page=1;
                this.mergePage()
            },
            //查询合并page
            mergePage(){
                let obj = JSON.parse(JSON.stringify(this.params))
                this.tableLoading = true
                this.$api.mergePage(obj).then(res=>{
                    this.tableLoading = false
                    if(res.respCode==0){
                        this.data=res.data.list;
                        this.total=res.data.total
                    }else{
                        this.$Message.error(res.resultMessage)
                    }
                })
            },

            //撤回
            withdraw(row){
                this.$util.confirmDialog(this, "确认撤回", '确认撤回该条审批申请吗？一旦撤回将无法恢复!', self => {
                    this.$api.mergeWithdraw({id:row.id}).then(res=>{
                        if(res.respCode==0){
                            this.$Message.success('撤回成功');
                            this.params.page=1;
                            this.mergePage()
                        }else{
                            this.$Message.error( res.message)
                        }
                    })
                })

            },


            quitApply(type,params){
                this.isSee = false
                if(type==='add'){
                    this.isReady=false;
                    this.isEdit=false;
                    this.areaList=[];
                    this.groupList=[];
                    this.teamList=[];
                    this.afterAreaList=[];
                    this.afterTeamList=[];
                    this.afterGroupList=[];
                    this.formValidate_teamMerge = {
                        changeAttachmentDTO: [],
                            changeType:4,
                            saveFlag:'',//	是	string	保存类型 0 提交申请 1 保存
                            agentName:'',//	是	string	新负责人姓名
                            agentCode:'',//	是	string	新负责人编码
                            postCode:'',//	否	string	岗位编码
                            postName:'',//	否	string	岗位名称
                            rankCode:'',//	是	string	职级编码
                            rankName:'',//	是	string	职级名称
                            effectiveDate:'',//	是	date	生效日期 yyyy-MM-dd
                            deptCode:'',//	是	string	管理机构编码
                            deptName:'',//	是	string	管理机构级名称
                            areaCode:'',//	是	string	申请合并营业区编码
                            areaName:'',//	是	string	申请合并营业区名称
                            teamCode:'',//	否	string	申请合并营业部编码
                            teamName:'',//	否	string	申请合并营业部名称
                            groupCode:'',//	否	string	申请合并营业组编码
                            groupName:'',//	否	string	申请合并营业组名称
                            changeMergeDTO:{
                            type:'1',//	是	string	合并类型 1-区合并；2-部合并；3-组合并
                                mergeToAreaCode:'',//	是	string	合并至营业区编码
                                mergeToArea:'',//	是	string	合并至营业区名称
                                mergeToTeamCode:'',//	否	string	合并至营业部编码
                                mergeToTeam:'',//	否	string	合并至营业部名称
                                mergeToGroupCode:'',//	否	string	合并至营业组编码
                                mergeToGroup:'',//	否	string	合并至营业组名称
                        }

                    }
                    this.$refs.formValidate_teamMerge.resetFields()
                    this.teamMergeModalFlag=true
                }else if(type==='ready'){
                    this.isReady=true;
                    this.isEdit=false;
                    this.areaList=this.companyList.areaList;
                    this.groupList=this.companyList.groupList;
                    this.teamList=this.companyList.teamList;
                    this.afterAreaList=this.companyList.afterAreaList;
                    this.afterTeamList=this.companyList.afterGroupList;
                    this.afterGroupList=this.companyList.afterTeamList;
                    this.getDetailById(params)
                }else if (type === 'edit'){
                    this.isReady=false;
                    this.isEdit=true;
                    this.areaList=this.companyList.areaList;
                    this.groupList=this.companyList.groupList;
                    this.teamList=this.companyList.teamList;
                    this.afterAreaList=this.companyList.afterAreaList;
                    this.afterTeamList=this.companyList.afterGroupList;
                    this.afterGroupList=this.companyList.afterTeamList;
                    this.getDetailById(params)
                } else {
                    //将申请人赋值给详情弹框里面
                    console.log(params)
                    this.curCreatedUser=params.createdUser
                    this.isSee = true
                    this.areaList=this.companyList.areaList;
                    this.groupList=this.companyList.groupList;
                    this.teamList=this.companyList.teamList;
                    this.afterAreaList=this.companyList.afterAreaList;
                    this.afterTeamList=this.companyList.afterGroupList;
                    this.afterGroupList=this.companyList.afterTeamList;
                    this.getDetailById(params)
                }
            }
        },
        computed:{

        },
        watch:{
            'formValidate_teamMerge.changeMergeDTO.mergeToAreaCode'(m,v){
                if (m) {
                    console.log('-----------');
                    console.log(m);
                }
            },
            isRank(m,v){
                if (m) {
                    this.isCexzl = false
                    this.formValidate_teamMerge.changeMergeDTO.type='1'
                }
            },
            isCexzl(m,v){
                if (m) {
                    this.isRank = false
                    this.formValidate_teamMerge.changeMergeDTO.type='2'
                }
            },
            //清空校验以及触发false 情况下新旧职级问题
            'formValidate_teamMerge.agentCode'(m,v){
                if(m) {
                    //可能遇到change之后表单的校验不清除  所有需要重置一下 并赋值
                    this.$refs.formValidate_teamMerge.fields.forEach( (e) => {
                        if (e.prop == 'agentCode') {
                            e.resetField()
                            this.formValidate_teamMerge.agentCode=m
                        }

                    })

                }
            }
        }
    }
</script>

<style scoped lang="less">
    #teamMerge {
        .header {
            .ivu-input,.ivu-select,.ivu-date-picker{
                width: 162px;
            }
        }
    }
 .fileStyle /deep/ .ivu-form-item-error-tip{
     display: none !important
 }
</style>
